import { useContext } from 'react';
import { SystemContext } from '../System';
import { MFAStore } from '../stores/MFAStore';

export function useMFAStore(): MFAStore {
  const system = useContext(SystemContext);
  return system.mfaStore;
}
